import React, { useState, useEffect} from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import MessageBox from "../../../components/MessageBox/MessageBox";
import Preloader from "../../../components/Preloader/Preloader";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "800px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
		maxHeight:"100%",
		overflow: "auto",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
		'&$disabled': {
			color: '#f2f2f2',
		 }
	},
	disabled: {},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function UpdateSystemUser(props) {
	const {user_id, user_details, showModal} = props;

	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [positionData, setPositionData] = useState([]);
	const [branchIdData, setBranchIdData] = useState([]);
	const [userData, setUserData] = useState([]);

	const [positionId, setPositionId] = useState(user_details.position_id);
	const [positionIndex, setPositionIndex] = useState(null); 
	const [branchIdNoIndex, setBranchIdNoIndex] = useState(null);
	const [fname, setFname] = useState('');
	const [mname, setMname] = useState('');
	const [lname, setLname] = useState('');
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState(null);
	const [branchidno, setBranchidno] = useState(user_details.branchidno);

	const [confirmPassword, setConfirmPassword] = useState(null);

	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF
	const [btnDisabled, setBtnDisabled] = useState(true);

	const handleOpen = () => {
		//getUserData();
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const getUserRoleData = async() => {
		await axios.get(process.env.REACT_APP_API_URL+'get_user_roles', {
			}).then(function (res) {
				setPositionData(res.data.data);

				res.data.data.some(function(entry, i) {
					if (entry.position == user_details.position) {
						//index = i;
						// console.log(user_details.position);
						// console.log(i);
						console.log(i);
						setPositionIndex(i);
						return true;
					}
				});
		  	}).catch(function (error) {	
				console.log(error);
	  		});
	}
	
	const getBranchIdData = async() => {
		await axios.get(process.env.REACT_APP_API_URL+'get_branches', {
			}).then(function (res) {
				setBranchIdData(res.data.data);
				res.data.data.some(function(entry, i) {
					if (entry.idno.trim() == user_details.branchidno.trim()) {
						console.log(entry.idno);
						console.log(user_details.branchidno);
						setBranchIdNoIndex(i);
						return true;
					}
				});
		  	}).catch(function (error) {	
				console.log(error);
	  		});
	}

	const setUserDetails = () => {
		setLname(user_details.lname);
		setMname(user_details.mname);
		setFname(user_details.fname);
		setUsername(user_details.username);
	}
	

	const selectSupplierProps = {
		options: positionData,
		getOptionLabel: (option) => option.position,
	};
	
	const selectBranchIdProps = {
		options: branchIdData,
		getOptionLabel: (option) => option.idno,
	};

	const getIndexofArray = async (property_value, type) => {
		//for position dropdown
		var index = '';
		console.log(positionData);
		console.log(branchIdData);
			if(type === 1){
				console.log('position');
				positionData.some(function(entry, i) {
					if (entry.position == property_value) {
						index = i;
						return true;
					}
				});
		//for branchidno dropdown
			}else if(type === 2){
				console.log('branchidno');
				branchIdData.some(function(entry, i) {
					if (entry.idno == property_value) {
						index = i;
						return true;
					}
				});
			}
		return index;
	}

	useEffect(() => { //
		if(user_id && open){
			setUserDetails();
			getUserRoleData();
			getBranchIdData();
		}
	}, [user_id, open]);

	useEffect(() => {
		if(password && confirmPassword){
			if (positionId && fname && mname && lname && username && (password===confirmPassword)) {
				setBtnDisabled(false); // re-enable
			} else {
				setBtnDisabled(true); // re-enable
			}
		}else{
			if (positionId && fname && mname && lname && username) {
				setBtnDisabled(false); // re-enable
			} else {
				setBtnDisabled(true); // re-enable
			}
		}
	}, [positionId,fname,mname,lname,username,password,confirmPassword]);
	// user_id:19
	// position_id:51
	// fname:Mark Daniel
	// mname:Calzita
	// lname:Babaylan
	// username:rakkit699
	// password:Test123
	// branchidno:DAVAOHQ
	const editSystemUser = async () => {
		if((password == confirmPassword) && fname && mname && lname && username && branchidno){
			const formData = new FormData();
			formData.append("user_id", user_id);
			formData.append("position_id", positionId);
			formData.append("fname", fname);
			formData.append("mname", mname);
			formData.append("lname", lname); 
			formData.append("username", username); 
			formData.append("password", password);
			formData.append("branchidno", branchidno);
	
			await axios.post(process.env.REACT_APP_API_URL+'edit_system_user', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					showModal('Updated System User'+ username, 'success');
					handleClose();
				  }).catch(function (error) {
					showModal('Something went wrong '+ error.message, 'warning');
					handleClose();
				  });
		}else{
			showModal('Passwords must match / Fields must not be empty', 'warning');
			// handleClose();
		}
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		editSystemUser();
    }

	const handleClickShowPassword = (flag) => {
		if(flag === 'password'){
			setShowPassword(!showPassword);
		}else if(flag === 'confirm'){
			setShowConfirmPassword(!showConfirmPassword);
		}
	  };

	  function hasNumber(myString) {
		if(myString!= ''){
			return /^[A-Za-z]+$/.test(myString);
		}else{
			return true;
		}
		//return /\d+/.test(myString);
	  }
	  
	  const validateUsername = (username) => {
		let isValidName = username.match(/^(([a-z])+([0-9])+|([a-z])+)/);
		if(!isValidName){
			setUsername('');
			setShowMsgBox(true);
			setMsgType('warning'); //success or warning
			setMsg('Invalid Username');
			setTimeout(() => {
				setShowMsgBox(false);
			}, 2000)
		}
	  };

	  const validateName = (username,flag) => {
		// let isValidName = username.match(/([a-z])|([A-Z])/);
		let isValidName = hasNumber(username);
		if(!isValidName){
			// setUsername('');
			if(flag==='fname'){
				setFname('');
			}else if(flag === 'mname'){
				setMname('');
			}else if(flag === 'lname'){
				setLname('');
			}
			setShowMsgBox(true);
			setMsgType('warning'); //success or warning
			setMsg('Numbers Not Allowed in Name Fields');
			setTimeout(() => {
				setShowMsgBox(false);
			}, 2000)
		}
	  };

	  const handleMouseDownPassword = (event) => {
		event.preventDefault();
	  };
	  const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);

	return (
		<div>
			<Button variant="contained" color="primary" onClick={handleOpen} style={{backgroundColor: "#4caf50", color:"#fff"}}>
				Edit
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
						<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
						<h4 id="transition-modal-title">Update System User</h4>
						{open && (positionIndex != null) && (branchIdNoIndex != null)? (<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={2}>
								<Grid item xs={12} xl={12}> 
									<Autocomplete
												{...selectSupplierProps}
												id="auto-complete"
												defaultValue={positionData[positionIndex]}
												autoComplete
												includeInputInList
												className={classes.autoComplete}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Select User Role"
														margin="normal"
														variant="outlined"
													/>
												)}
												onChange={(event, newValue) => {
													if (!newValue == "" || !newValue == null){
														console.log(newValue);
														setPositionId(newValue.position_id);
													}else{
														setPositionId(null);
													}
												}}
									/>
								</Grid>		
								<Grid item xs={12} md={4} lg={4} xl={4}> 
									<TextField id="outlined-basic" style={{'marginTop':'16px'}} label="User Name" variant="outlined" placeholder="User Name" inputProps={{ 'aria-label': 'User Name' }} value={username} 
									onChange={e => setUsername(e.target.value)}
									onBlur={(e)=>{validateUsername(e.target.value)}}/>
								</Grid>	
								<Grid item xs={12} md={8} lg={8} xl={8}>
									{/* <TextField id="outlined-basic" label="Branch Id No" variant="outlined" placeholder="Branch Id No" inputProps={{ 'aria-label': 'User Name' }} value={branchidno} onChange={e => setBranchidno(e.target.value)}/> */}
									<Autocomplete
												{...selectBranchIdProps}
												id="auto-complete"
												defaultValue={branchIdData[branchIdNoIndex]}
												autoComplete
												includeInputInList
												className={classes.autoComplete}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Select Branch Id No."
														margin="normal"
														variant="outlined"
													/>
												)}
												onChange={(event, newValue) => {
													if (!newValue == "" || !newValue == null){
														console.log(newValue);
														setBranchidno(newValue.idno);
													}
												}}
									/>
								</Grid>	
								<Grid item xs={12} md={6} lg={6} xl={6}> 
									<InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
        							  <OutlinedInput
        							    id="outlined-adornment-password"
        							    type={showPassword ? 'text' : 'password'}
        							    value={password}
										fullWidth={true} 
        							    onChange={e => setPassword(e.target.value)}
        							    endAdornment={
        							      <InputAdornment position="end">
        							        <IconButton
        							          aria-label="toggle password visibility"
        							          onClick={()=>{handleClickShowPassword('password')}}
        							          onMouseDown={handleMouseDownPassword}
        							          edge="end"
        							        >
        							          {showPassword ? <Visibility /> : <VisibilityOff />}
        							        </IconButton>
        							      </InputAdornment>
        							    }
        							    labelWidth={50}
        							/>
								</Grid>
								<Grid item xs={12} md={6} lg={6} xl={6}> 
									<InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
        							  <OutlinedInput
        							    id="outlined-adornment-password"
										fullWidth={true} 
        							    type={showConfirmPassword ? 'text' : 'password'}
        							    value={confirmPassword}
        							    onChange={e => setConfirmPassword(e.target.value)}
        							    endAdornment={
        							      <InputAdornment position="end">
        							        <IconButton
        							          aria-label="toggle password visibility"
        							          onClick={()=>{handleClickShowPassword('confirm')}}
        							          onMouseDown={handleMouseDownPassword}
        							          edge="end"
        							        >
        							          {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
        							        </IconButton>
        							      </InputAdornment>
        							    }
        							    labelWidth={50}
        							/>
								</Grid>
								<Grid item xs={12} md={4} lg={4} xl={4}> 
									<TextField id="outlined-basic" 
										label="First Name" 
										variant="outlined"  style={{marginTop:"21px"}} 
										placeholder="First Name" fullWidth={true} 
										inputProps={{ 'aria-label': 'First Name'}} 
										value={fname} 
										onChange={e => setFname(e.target.value)}
										onBlur={(e)=>{validateName(e.target.value,'fname')}}
									/>
								</Grid>	
								<Grid item xs={12} md={4} lg={4} xl={4} > 
									<TextField id="outlined-basic" label="Middle Name" variant="outlined"  style={{marginTop:"21px"}} fullWidth={true} placeholder="Middle Name" inputProps={{ 'aria-label': 'Middle Name' }} value={mname} onChange={e => setMname(e.target.value)} onBlur={(e)=>{validateName(e.target.value,'mname')}}/>
								</Grid>
								<Grid item xs={12} md={4} lg={4} xl={4}> 
									<TextField id="outlined-basic" label="Last Name" variant="outlined"  style={{marginTop:"21px"}} fullWidth={true} placeholder="Last Name" inputProps={{ 'aria-label': 'Last Name' }} value={lname} onChange={e => setLname(e.target.value)} onBlur={(e)=>{validateName(e.target.value,'lname')}}/>
								</Grid>
							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
								<ColorButton type="submit" disabled={btnDisabled} variant="contained" color="primary" classes={{
    									root: classes.root, 
        								disabled: classes.disabled}}>
									Save
								</ColorButton>
							</div>
						</form>) : (<Preloader />)}	
					</div>
				</Fade>
			</Modal>
		</div>
	);
}
